var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSmallClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_small_close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.16736755,3.16736755 C3.39052429,2.94421082 3.75233285,2.94421082 3.97548959,3.16736755 L3.97548959,3.16736755 L7,6.192 L10.0245104,3.16736755 C10.222872,2.96900601 10.5307856,2.94696584 10.753492,3.10124704 L10.8326324,3.16736755 C11.0557892,3.39052429 11.0557892,3.75233285 10.8326324,3.97548959 L10.8326324,3.97548959 L7.808,7 L10.8326324,10.0245104 C11.030994,10.222872 11.0530342,10.5307856 10.898753,10.753492 L10.8326324,10.8326324 C10.6094757,11.0557892 10.2476671,11.0557892 10.0245104,10.8326324 L10.0245104,10.8326324 L7,7.808 L3.97548959,10.8326324 C3.77712804,11.030994 3.46921444,11.0530342 3.246508,10.898753 L3.16736755,10.8326324 C2.94421082,10.6094757 2.94421082,10.2476671 3.16736755,10.0245104 L3.16736755,10.0245104 L6.192,7 L3.16736755,3.97548959 C2.96900601,3.77712804 2.94696584,3.46921444 3.10124704,3.246508 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_small_close",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#5697B7",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmallClose);
export default __webpack_public_path__ + "static/media/icon_small_close.00b6725e33677e2d9fa023b546ca0ace.svg";
export { ForwardRef as ReactComponent };